import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector, batch } from 'react-redux';
import QuarterlyPerformance from './components/QuarterlyPerformance';
import AssetBreakdownTwo from './components/AssetBreakdownTwo';
import ChainSplit from './components/ChainSplit';
import AssetBreakdown from './components/AssetBreakdown';
import Transaction from './components/transaction';
import Spinner from '../../components/Spinner';
import {
  getDefiChain,
  getDefiOverview,
  getQuarterlyPerformance,
  defiOverviewSelector,
  getDefiPerformanceSummary,
  actions,
} from '../../store/defi/overview';
import EmptyState from '../../components/EmptyState';
import { defiTransactionsSelector, getDefiDashboardTransactions } from '../../store/defi/transactionsSlice';

const Index = () => {
  const dispatch = useDispatch();
  const {
    loading,
    quarterly_performance,
    chain_asset_breakdown,
    token_chain_breakdown,
    chain_total_amounts,
    performance_summary,
    available_chains,
  } = useSelector(defiOverviewSelector);
  const { transactionsDashboard } = useSelector(defiTransactionsSelector);
  const [_transactions, setTransaction] = useState([]);
  const [quarterlyPerformance, setQuarterlyPerformance] = useState();
  const [performanceSummary, setPerformanceSummary] = useState();

  useEffect(() => {
    batch(() => {
      dispatch(getDefiChain());
      dispatch(getQuarterlyPerformance());
      dispatch(getDefiDashboardTransactions());
      dispatch(getDefiPerformanceSummary());
    });
  }, [dispatch]);

  useEffect(() => {
    setTransaction(transactionsDashboard);
    setQuarterlyPerformance(quarterly_performance);
    setPerformanceSummary(performance_summary);
  }, [transactionsDashboard, quarterly_performance, performance_summary]);

  return (
    <>
      {loading ? (
        <Spinner />
      ) : (
        <div className="custom_dashboard" style={{ display: 'flex' }}>
          <div style={{ width: '66.5%' }}>
            <div className="" style={{ width: '100%' }}>
              <QuarterlyPerformance
                data={quarterlyPerformance}
                performance_summary={performanceSummary}
              />
            </div>
            <div>
              <div style={{ width: '100%' }}>
                <AssetBreakdown
                  chain_asset_breakdown={token_chain_breakdown}
                  available_chains={available_chains}
                />
              </div>
              <div style={{ width: '100%', display: 'flex' }}>
                <div style={{ width: '50%' }}>
                  <AssetBreakdownTwo chain_asset_breakdown={chain_asset_breakdown} />
                </div>
                <div style={{ width: '50%' }}>
                  <ChainSplit chain_total_amounts={chain_total_amounts} />
                </div>
              </div>
            </div>
          </div>

          <div
            className="slds-col slds-size_4-of-12"
            style={{ position: 'sticky', top: '0' }}
          >
            {_transactions && _transactions.length ? (
              <Transaction transactions={_transactions} />
            ) : (
              <div
                className="home_card home_transaction defi_transaction defi_card"
                style={{
                  height: '500px',
                  display: 'flex',
                }}
              >
                <EmptyState />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Index;
